/*
 * @Author: zyq
 * @Date: 2022-10-21 16:30:24
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-26 01:41:38
 * @description:
 */
export default {
  namespaced: true,

  // 数据节点
  state: () => ({
    homemusic: false,
    showExamRequire: false
  }),

  // 方法节点
  mutations: {
    updateHomeMusic (state, music) {
      state.homemusic = music
    },
    updateShowExamRequire (state, show) {
      state.showExamRequire = show
    }
  },

  // 属性节点
  getters: {}

}
